import { Form } from 'antd';
import type { FC } from 'react';

import { FormLegacyRenderProp } from 'app/components/forms/FormLegacyRenderProp';
import { Card } from 'app/components/layout/Card';
import type { Hotel } from 'app/typings/builder/hotel';

import { HeaderWrapper } from '../HeaderWrapper/HeaderWrapper';

import { CommunicationForm } from './Communication/Communication';

export const ProfileForm: FC<Props> = ({
  handleSubmit,
  initialValue,
  originalBillingEmails,
  isLoading = false,
}) => {
  const [form] = Form.useForm();

  return (
    <HeaderWrapper
      nextDisabled={false}
      handleNext={() => form.submit()}
      isLoading={isLoading}
    >
      <Card formOnly title="Profile">
        <FormLegacyRenderProp
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValue}
        >
          {(values, { setFieldsValue }) => (
            <CommunicationForm
              values={values}
              setFieldsValue={setFieldsValue}
              originalBillingEmails={originalBillingEmails}
            />
          )}
        </FormLegacyRenderProp>
      </Card>
    </HeaderWrapper>
  );
};

type Props = {
  handleSubmit: (payload: Hotel) => void;
  initialValue: Hotel;
  originalBillingEmails: string[] | undefined;
  isLoading?: boolean;
};
